export enum WrapType {
  NotApplicable,
  Wrap,
  Unwrap,
}
